import { MutationTree } from "vuex";
import { Job } from "@/types";
import { IDataProvider } from "@/store";
import { IJobState } from "@/store/modules/job/state";

export enum JobMutations {
  SET_ONE = "SET_ONE_JOB",
  SET_ALL = "SET_ALL_JOB",
  SET_LAZY_DATA = "SET_LAZY_DATA_JOB",
}

export const mutations: MutationTree<IJobState> = {
  [JobMutations.SET_ONE](state, payload: Job) {
    state.job = payload;
  },
  [JobMutations.SET_ALL](state, payload: Job[]) {
    state.jobs = payload;
  },
  [JobMutations.SET_LAZY_DATA](state, payload: IDataProvider<Job>) {
    state.dataProvider = payload;
  },
};
